import styled, { css } from 'styled-components';
import { colors, spacing, typography } from '@izettle/otto';
import { SemanticState } from '../../enumerations/semantic-state.js';

const mixinInputControlRightPalette = css`
  color: ${_ref => {
  let {
    semanticState,
    isFocused,
    isDisabled
  } = _ref;
  if (isDisabled) {
    return colors.icon.disabled;
  }
  if (isFocused) {
    return colors.icon.action;
  }
  return {
    [SemanticState.Warning]: colors.icon.warning.small,
    [SemanticState.Error]: colors.icon.error.small,
    [SemanticState.Success]: colors.icon.success.small,
    [SemanticState.Default]: colors.icon.default
  }[semanticState ?? SemanticState.Default];
}};
`;
const InputCustomIcon = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__InputCustomIcon",
  componentId: "zettle__sc-bv39ze-0"
})(["display:flex;align-items:center;justify-content:center;padding-right:", ";", ""], spacing.small, mixinInputControlRightPalette);
const InputCustomIconLeft = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__InputCustomIconLeft",
  componentId: "zettle__sc-bv39ze-1"
})(["min-width:", ";max-width:", ";margin-left:", ";overflow:hidden;padding:0;display:flex;white-space:nowrap;justify-content:center;align-items:center;", " ", ""], spacing.medium, spacing.medium, spacing.small, typography.large, mixinInputControlRightPalette);

export { InputCustomIcon, InputCustomIconLeft };
//# sourceMappingURL=styles.js.map
